export default "__VITE_ASSET__DZZNmg1M__"